import React, { useState } from 'react';
import { 
  Table, Tag, Space, Button, Card, Row, Col, Form, Input, InputNumber, Select, 
  DatePicker, Typography, Modal, Descriptions, Tabs, Upload, Radio, Tree, Drawer
} from 'antd';
import { 
  SearchOutlined, ReloadOutlined, PlusOutlined, 
  TeamOutlined, SafetyCertificateOutlined, ExceptionOutlined, CloseCircleOutlined,
  LeftOutlined
} from '@ant-design/icons';
import './SubEnterprise.css';
import BusinessConfig, { AdCommissionConfig, PrivateDeployBizSection } from '../BusinessConfig/BusinessConfig';

const { Option } = Select;
const { RangePicker } = DatePicker;

// ══════════════════════════════════════════════
//  平台客户（菜单路径：企业管理 → 平台客户）
//  功能：企业列表 + 企业详情（Tab：资料信息/商务信息）
//  企业详情为内嵌 view 模式，非独立路由
// ══════════════════════════════════════════════

const SubEnterprise = () => {
  const [view, setView] = useState('list'); // 'list' | 'detail'
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [isAuditModalVisible, setIsAuditModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [createForm] = Form.useForm();
  const [auditForm] = Form.useForm();

  const allMenuTree = [
    { title: '首页', key: '1' },
    { title: '物模型管理', key: '2', children: [
      { title: 'IOT类目', key: '2-1', children: [{ title: '新增类目', key: '2-1-1' }, { title: '删除类目', key: '2-1-2' }] },
      { title: '设备能力', key: '2-2' },
    ]},
    { title: '产品管理', key: '3', children: [
      { title: '产品开发', key: '3-1' },
      { title: '产品审核', key: '3-2', children: [{ title: '通过审核', key: '3-2-1' }, { title: '驳回审核', key: '3-2-2' }] },
    ]},
    { title: '应用服务', key: '5', children: [{ title: '应用管理', key: '5-1' }, { title: '套餐管理', key: '5-2' }, { title: '平台商户号', key: '5-3' }, { title: '企业商户号', key: '5-4' }] },
    { title: '订单管理', key: '6', children: [{ title: '增值订单', key: '6-1' }] },
    { title: '设备管理', key: '7', children: [{ title: '设备列表', key: '7-1' }] },
    { title: '数据统计', key: '8', children: [{ title: '用户统计', key: '8-1' }, { title: '收入统计', key: '8-2' }] },
  ];
  const roleMenuKeys = {
    '应用服务商': ['1', '3', '5', '6'],
    '设备制造商': ['1', '2', '3', '7'],
    '渠道商': ['1', '3', '6'],
    '运营商': ['1', '3', '5', '6', '8'],
  };
  const getMenuTreeByRoles = (roles) => {
    const allowedKeys = new Set((roles || []).flatMap(r => roleMenuKeys[r] || []));
    return allMenuTree.filter(n => allowedKeys.has(n.key));
  };
  const getAllKeys = (nodes) => nodes.flatMap(n => [n.key, ...getAllKeys(n.children || [])]);

  // 模拟数据
  const mockData = [
    {
      key: '1',
      index: 1,
      enterpriseName: '111',
      enterpriseId: 'CV3YyaGN8Y1xKFqk',
      aliasName: '深圳芯视界',
      entryType: 1,
      uniqueId: 'B8P',
      phone: '18115178069',
      contact: '1',
      contactPhone: '18115178069',
      registerTime: '2026-02-27 11:11:22',
      status: '待审核',
      creditCode: '91320000MA1EXAMPLE',
      licenseUrl: '',
      account: 'admin111',
      roles: ['应用服务商'],
      legalPerson: '张三',
      size: '50-100人',
      address: '江苏省南京市建邺区XX路88号',
      email: 'admin@111.com',
      contactRole: '技术总监',
      description: '测试企业简介',
      accounts: [
        { key: '1', account: 'admin111', phone: '18115178069', accountType: '默认注册', roles: ['应用服务商'], time: '2026-02-27 11:11:22' }
      ]
    },
    {
      key: '2',
      index: 2,
      enterpriseName: '测试企业1112',
      enterpriseId: 'CV34nx5JihVELUZC',
      aliasName: '测试企业1112',
      entryType: 2,
      uniqueId: '4Nr',
      phone: '',
      contact: '',
      contactPhone: '',
      registerTime: '2026-02-27 11:09:23',
      status: '已认证',
      creditCode: '91320000MA2EXAMPLE',
      licenseUrl: '',
      account: 'ssdkzs',
      roles: ['设备制造商', '渠道商'],
      legalPerson: '李四',
      size: '100-500人',
      address: '上海市浦东新区XX路66号',
      email: 'contact@test1112.com',
      contactRole: '项目经理',
      description: '测试企业1112简介',
      accounts: [
        { key: '1', account: 'ssdkzs', phone: '', accountType: '默认注册', roles: ['设备制造商', '渠道商'], time: '2026-02-27 03:09:24' },
        { key: '2', account: 'sub_user01', phone: '13800001111', accountType: '子账号', roles: ['渠道商'], time: '2026-02-28 10:00:00' }
      ]
    },
    {
      key: '3',
      index: 3,
      enterpriseName: 'wd2-com',
      enterpriseId: 'CV39IR3a9AcfxxJK',
      aliasName: 'WD2',
      entryType: 1,
      uniqueId: 'PZw',
      phone: '15662166152',
      contact: '11',
      contactPhone: '15662166152',
      registerTime: '2026-02-26 14:33:41',
      status: '已认证',
      creditCode: '91320000MA3EXAMPLE',
      licenseUrl: '',
      account: 'wd2admin',
      roles: ['运营商'],
      legalPerson: '王五',
      size: '20-50人',
      address: '北京市朝阳区XX大厦12层',
      email: 'info@wd2.com',
      contactRole: 'CEO',
      description: 'wd2-com公司简介',
      accounts: [
        { key: '1', account: 'wd2admin', phone: '15662166152', accountType: '默认注册', roles: ['运营商'], time: '2026-02-26 14:33:41' }
      ]
    }
  ];

  const columns = [
    { title: '序号', dataIndex: 'index', key: 'index', width: 60, align: 'center' },
    { title: '企业信息', key: 'enterpriseInfo', render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.enterpriseName}</div><div style={{ fontSize: 12, color: '#8c8c8c' }}>ID: {r.enterpriseId}</div></div>) },
    { title: '唯一标识码', dataIndex: 'uniqueId', key: 'uniqueId' },
    { title: '企业别名', dataIndex: 'aliasName', key: 'aliasName', width: 140, ellipsis: true, render: (v) => v || '-' },
    { title: '入驻类型', dataIndex: 'entryType', key: 'entryType', width: 110, render: (v) => (Number(v) === 2 ? '测试企业' : '常规企业') },
    { title: '注册手机号', dataIndex: 'phone', key: 'phone' },
    { title: '联系人', dataIndex: 'contact', key: 'contact' },
    { title: '联系人电话', dataIndex: 'contactPhone', key: 'contactPhone' },
    { title: '注册时间', dataIndex: 'registerTime', key: 'registerTime' },
    { 
      title: '认证状态', 
      dataIndex: 'status', 
      key: 'status',
      render: (status) => {
        const colorMap = { '待审核': 'orange', '已认证': 'green', '已拒绝': 'red' };
        return <Tag color={colorMap[status]}>{status}</Tag>;
      }
    },
    { 
      title: '操作', 
      key: 'action',
      render: (_, record) => (
        <Space size="small">
          {record.status === '待审核' && (
            <Button type="link" size="small" onClick={(e) => {
              e.stopPropagation();
              setIsAuditModalVisible(true);
              setSelectedRecord(record);
            }} style={{ padding: 0 }}>审核</Button>
          )}
          <Button type="link" size="small" onClick={() => {
            setSelectedRecord(record);
            setView('detail');
          }} style={{ padding: 0 }}>查看详情</Button>
        </Space>
      )
    },
  ];

  const onReset = () => {
    form.resetFields();
  };

  const handleCreate = () => {
    setIsCreateModalVisible(false);
    createForm.resetFields();
  };

  const handleAudit = () => {
    setIsAuditModalVisible(false);
    auditForm.resetFields();
  };

  // 审核弹窗（列表页和详情页共用）
  const auditModal = (
    <Modal
      title="认证审核"
      open={isAuditModalVisible}
      onCancel={() => { setIsAuditModalVisible(false); auditForm.resetFields(); }}
      onOk={handleAudit}
      width={560}
      okText="确认"
      cancelText="取消"
    >
      <Form form={auditForm} layout="horizontal" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }} initialValues={{ auditStatus: 'pass', licenseDiscount: 100 }}>
        <Form.Item label="认证审核" name="auditStatus">
          <Radio.Group onChange={() => auditForm.resetFields(['roles', 'rejectReason', 'licenseDiscount'])}>
            <Radio value="pass">通过</Radio>
            <Radio value="reject">拒绝</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item shouldUpdate={(prev, cur) => prev.auditStatus !== cur.auditStatus} noStyle>
          {({ getFieldValue }) => getFieldValue('auditStatus') === 'pass' ? (
            <>
              <Form.Item
                label="License折扣"
                name="licenseDiscount"
                rules={[{ required: true, message: '请输入License折扣' }]}
              >
                <InputNumber min={0} max={100} precision={0} addonAfter="%" style={{ width: 200 }} />
              </Form.Item>
              <Form.Item
                label="角色权限"
                name="roles"
                rules={[{ required: true, message: '请选择角色权限' }]}
              >
                <Select mode="multiple" placeholder="请选择角色权限">
                  <Option value="应用服务商">应用服务商</Option>
                  <Option value="设备制造商">设备制造商</Option>
                  <Option value="渠道商">渠道商</Option>
                  <Option value="运营商">运营商</Option>
                </Select>
              </Form.Item>
              <Form.Item shouldUpdate={(prev, cur) => prev.roles !== cur.roles} noStyle>
                {({ getFieldValue: getVal }) => {
                  const selectedRoles = getVal('roles') || [];
                  const filtered = getMenuTreeByRoles(selectedRoles);
                  if (filtered.length === 0) return null;

                  return (
                    <Form.Item label="合并后菜单">
                      <div style={{ border: '1px solid #d9d9d9', borderRadius: 6, padding: '8px 4px', maxHeight: 260, overflowY: 'auto' }}>
                        <Tree
                          treeData={filtered}
                          expandedKeys={getAllKeys(filtered)}
                          selectable={false}
                        />
                      </div>
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </>
          ) : (
            <Form.Item
              label="拒绝原因"
              name="rejectReason"
              rules={[{ required: true, message: '请输入拒绝原因' }]}
            >
              <Input.TextArea rows={3} placeholder="请输入拒绝原因" maxLength={200} showCount />
            </Form.Item>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );

  if (view === 'detail') {
    const r = selectedRecord || {};
    return (
      <div className="sub-enterprise-detail">
        <div className="detail-header" onClick={() => setView('list')} style={{ cursor: 'pointer', marginBottom: 16 }}>
          <LeftOutlined /> 返回 | <strong>企业详情</strong>
        </div>
        
        <Card style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <h2 style={{ margin: 0 }}>{r.enterpriseName}</h2>
                <Tag color={{ '待审核': 'orange', '已认证': 'green', '已拒绝': 'red' }[r.status]}>{r.status}</Tag>
              </div>
              <p style={{ color: '#999', marginTop: 8 }}>注册于 {r.registerTime}</p>
            </div>
            {r.status === '待审核' && (
              <Button type="primary" onClick={() => setIsAuditModalVisible(true)}>立即审核</Button>
            )}
          </div>
        </Card>

        <Card>
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="资料信息" key="1">
              <Descriptions bordered column={2}>
                <Descriptions.Item label="企业名称">{r.enterpriseName}</Descriptions.Item>
                <Descriptions.Item label="企业别名">{r.aliasName || '-'}</Descriptions.Item>
                <Descriptions.Item label="企业ID">{r.enterpriseId}</Descriptions.Item>
                <Descriptions.Item label="唯一标识码">{r.uniqueId}</Descriptions.Item>
                <Descriptions.Item label="入驻类型">{Number(r.entryType) === 2 ? '测试企业' : '常规企业'}</Descriptions.Item>
                <Descriptions.Item label="统一社会信用代码">{r.creditCode || '-'}</Descriptions.Item>
                <Descriptions.Item label="营业执照" span={2}>
                  {r.licenseUrl ? <img src={r.licenseUrl} alt="营业执照" style={{ maxWidth: 200 }} /> : '-'}
                </Descriptions.Item>
                <Descriptions.Item label="注册手机号">{r.phone || '-'}</Descriptions.Item>
                <Descriptions.Item label="登录账号">{r.account || '-'}</Descriptions.Item>
                <Descriptions.Item label="企业角色" span={2}>
                  {(r.roles || []).map(role => <Tag color="blue" key={role}>{role}</Tag>)}
                  {(!r.roles || r.roles.length === 0) && '-'}
                </Descriptions.Item>
                <Descriptions.Item label="法定代表人">{r.legalPerson || '-'}</Descriptions.Item>
                <Descriptions.Item label="公司规模">{r.size || '-'}</Descriptions.Item>
                <Descriptions.Item label="公司地址" span={2}>{r.address || '-'}</Descriptions.Item>
                <Descriptions.Item label="联系人">{r.contact || '-'}</Descriptions.Item>
                <Descriptions.Item label="联系人电话">{r.contactPhone || '-'}</Descriptions.Item>
                <Descriptions.Item label="联系邮箱">{r.email || '-'}</Descriptions.Item>
                <Descriptions.Item label="联系人职务">{r.contactRole || '-'}</Descriptions.Item>
                <Descriptions.Item label="注册时间">{r.registerTime}</Descriptions.Item>
                <Descriptions.Item label="认证状态">
                  <Tag color={{ '待审核': 'orange', '已认证': 'green', '已拒绝': 'red' }[r.status]}>{r.status}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="公司简介" span={2}>{r.description || '-'}</Descriptions.Item>
              </Descriptions>
            </Tabs.TabPane>
            <Tabs.TabPane tab="基础商务" key="3">
              <BusinessConfig isPlatform={true} enterpriseName={r.enterpriseName} section="base" />
            </Tabs.TabPane>
            <Tabs.TabPane tab="底价与抽佣" key="6">
              <BusinessConfig isPlatform={true} enterpriseName={r.enterpriseName} section="price" />
            </Tabs.TabPane>
            <Tabs.TabPane tab="App广告抽佣" key="4">
              <AdCommissionConfig isPlatform={true} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="私有化部署" key="5">
              <PrivateDeployBizSection isPlatform={true} enterpriseName={r.enterpriseName} />
            </Tabs.TabPane>
          </Tabs>
        </Card>

        {auditModal}
      </div>
    );
  }

  return (
    <div className="sub-enterprise-container" style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16 }}>
        <Typography.Title level={4}>企业管理</Typography.Title>
      </div>
      {/* 统计卡片 */}
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={6}>
          <Card className="stat-card">
            <div className="stat-content">
              <div className="stat-info">
                <div className="stat-label">企业总数</div>
                <div className="stat-value">28</div>
              </div>
              <div className="stat-icon blue"><TeamOutlined /></div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stat-card">
            <div className="stat-content">
              <div className="stat-info">
                <div className="stat-label">已认证</div>
                <div className="stat-value">26</div>
              </div>
              <div className="stat-icon green"><SafetyCertificateOutlined /></div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stat-card">
            <div className="stat-content">
              <div className="stat-info">
                <div className="stat-label">待审核</div>
                <div className="stat-value">1</div>
              </div>
              <div className="stat-icon orange"><ExceptionOutlined /></div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stat-card">
            <div className="stat-content">
              <div className="stat-info">
                <div className="stat-label">未通过</div>
                <div className="stat-value">1</div>
              </div>
              <div className="stat-icon red"><CloseCircleOutlined /></div>
            </div>
          </Card>
        </Col>
      </Row>

      {/* 搜索表单 */}
      <Card style={{ marginBottom: 16 }}>
        <Form form={form} layout="inline">
          <Form.Item name="enterpriseNameVal">
            <Input placeholder="请输入企业名称/别名" allowClear style={{ width: 220 }} maxLength={20} />
          </Form.Item>
          <Form.Item name="keyword">
            <Input placeholder="请输入企业ID" allowClear style={{ width: 180 }} maxLength={20} />
          </Form.Item>
          <Form.Item name="phone">
            <Input placeholder="注册手机号" allowClear style={{ width: 160 }} maxLength={20} />
          </Form.Item>
          <Form.Item name="contact">
            <Input placeholder="联系人" allowClear style={{ width: 140 }} maxLength={20} />
          </Form.Item>
          <Form.Item name="uniqueId">
            <Input placeholder="唯一识别码" allowClear style={{ width: 160 }} maxLength={20} />
          </Form.Item>
          <Form.Item name="status">
            <Select placeholder="认证状态" allowClear style={{ width: 120 }}>
              <Option value="pending">待审核</Option>
              <Option value="approved">已认证</Option>
              <Option value="rejected">已拒绝</Option>
            </Select>
          </Form.Item>
          <Form.Item name="entryType">
            <Select placeholder="入驻类型" allowClear style={{ width: 130 }}>
              <Option value={1}>常规企业</Option>
              <Option value={2}>测试企业</Option>
            </Select>
          </Form.Item>
          <Form.Item name="registerDate" label="">
            <RangePicker placeholder={['注册开始日期', '注册结束日期']} />
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type="primary" icon={<SearchOutlined />}>查询</Button>
              <Button icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      {/* 操作与列表 */}
      <Card>
        <div style={{ marginBottom: 16 }}>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsCreateModalVisible(true)}>创建企业</Button>
        </div>
        <Table 
          columns={columns} 
          dataSource={mockData} 
          bordered
          scroll={{ x: 1400 }}
          pagination={{
            showTotal: (total) => `共${total}条记录`,
            defaultPageSize: 10,
            showSizeChanger: true,
            current: 1,
            pageSizeOptions: ['10', '20', '30']
          }}
        />
      </Card>

      {/* 创建企业抽屉 */}
      <Drawer
        title="创建企业"
        width={600}
        open={isCreateModalVisible}
        onClose={() => { setIsCreateModalVisible(false); createForm.resetFields(); }}
        destroyOnClose
        footer={
          <div style={{ textAlign: 'right' }}>
            <Space>
              <Button onClick={() => { setIsCreateModalVisible(false); createForm.resetFields(); }}>取消</Button>
              <Button type="primary" onClick={handleCreate}>保存</Button>
            </Space>
          </div>
        }
      >
        <Form form={createForm} layout="horizontal" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} initialValues={{ entryType: 1 }}>
          <Form.Item label="入驻类型" name="entryType">
            <Radio.Group>
              <Radio value={1}>常规企业</Radio>
              <Radio value={2}>测试企业</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item shouldUpdate={(prev, cur) => prev.entryType !== cur.entryType} noStyle>
            {({ getFieldValue }) => getFieldValue('entryType') === 2 ? (
              <Form.Item label="企业名称" name="name" rules={[{ required: true, message: '请输入企业名称' }]}>
                <Input addonBefore="平台测试_" placeholder="请输入" />
              </Form.Item>
            ) : (
              <Form.Item label="企业名称" name="name" rules={[{ required: true, message: '请输入企业名称' }]}>
                <Input placeholder="请输入" />
              </Form.Item>
            )}
          </Form.Item>
          <Form.Item label="企业别名" name="aliasName">
            <Input placeholder="请输入（非必填）" />
          </Form.Item>
          <Form.Item label="统一社会信用代码" name="code" rules={[{ required: true, message: '请输入统一社会信用代码' }]}>
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item label="营业执照" name="license" rules={[{ required: true, message: '请上传营业执照' }]}>
            <Upload listType="picture-card" maxCount={1} beforeUpload={() => false}>
              <div><PlusOutlined /><div style={{ marginTop: 8 }}>上传</div></div>
            </Upload>
          </Form.Item>
          <Form.Item label="注册手机号" name="phone" rules={[{ required: true, message: '请输入注册手机号' }]}>
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item label="管理员账号" name="account" rules={[{ required: true, message: '请输入管理员账号' }]}>
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item label="管理员密码" name="password" rules={[{ required: true, message: '请输入管理员密码' }]}>
            <Input.Password placeholder="请输入" />
          </Form.Item>
          <Form.Item label="企业角色" name="roles" rules={[{ required: true, message: '请选择企业角色' }]}>
            <Select mode="multiple" placeholder="请选择企业角色">
              <Option value="应用服务商">应用服务商</Option>
              <Option value="设备制造商">设备制造商</Option>
              <Option value="渠道商">渠道商</Option>
              <Option value="运营商">运营商</Option>
            </Select>
          </Form.Item>
          <Form.Item shouldUpdate={(prev, cur) => prev.roles !== cur.roles} noStyle>
            {({ getFieldValue: getVal }) => {
              const selectedRoles = getVal('roles') || [];
              const filtered = getMenuTreeByRoles(selectedRoles);
              if (filtered.length === 0) return null;
              return (
                <Form.Item label="合并后菜单">
                  <div style={{ border: '1px solid #d9d9d9', borderRadius: 6, padding: '8px 4px', maxHeight: 260, overflowY: 'auto' }}>
                    <Tree treeData={filtered} expandedKeys={getAllKeys(filtered)} selectable={false} />
                  </div>
                </Form.Item>
              );
            }}
          </Form.Item>
          <Form.Item label="法定代表人" name="legalPerson"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="公司规模" name="size"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="公司地址" name="address"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="联系人" name="contact"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="联系邮箱" name="email"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="联系人职务" name="contactRole"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="联系人电话" name="contactPhone"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="公司简介" name="description"><Input.TextArea rows={4} placeholder="请输入公司简介" /></Form.Item>
        </Form>
      </Drawer>

      {auditModal}
    </div>
  );
};

export default SubEnterprise;
